const features = [
  {
    icon: 'ri-team-line',
    title: 'Réseau Privé Sélectionné',
    desc: 'Un espace réservé aux profils sérieux. Pas de bruit, pas de réseau généraliste. Que des sportifs et entrepreneurs triés sur le volet.',
    stat: '+120',
    statLabel: 'membres actifs',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Experts Dédiés',
    desc: 'Avocat, comptable, CGP, courtier — des experts spécialisés reconversion sportive, disponibles directement via la plateforme.',
    stat: '12',
    statLabel: 'experts disponibles',
  },
  {
    icon: 'ri-route-line',
    title: 'Parcours Structuré',
    desc: 'Une méthode en 5 phases pour passer du sport au business sans improviser. Chaque étape validée, chaque décision éclairée.',
    stat: '5',
    statLabel: 'phases de reconversion',
  },
  {
    icon: 'ri-calendar-event-line',
    title: 'Événements Exclusifs',
    desc: 'Soirées networking privées, tables rondes, rencontres avec des experts. Des moments réels pour construire des connexions vraies.',
    stat: '4',
    statLabel: 'événements / an',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Analytics & Visibilité',
    desc: 'Suivez votre progression, votre impact dans le réseau et l\'évolution de votre projet en temps réel depuis votre tableau de bord.',
    stat: '100%',
    statLabel: 'transparent',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Accès Contrôlé',
    desc: 'Chaque profil est validé avant d\'accéder au réseau. La qualité des membres est notre engagement envers vous.',
    stat: 'Sur',
    statLabel: 'invitation',
  },
];

const FeaturesSection = () => {
  return (
    <section className="bg-[#080C1E] py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#C9A227]/10 border border-[#C9A227]/20 rounded-full mb-5">
            <i className="ri-sparkling-line text-[#C9A227] text-xs"></i>
            <span className="text-[#C9A227] text-xs font-semibold tracking-widest uppercase">Ce que vous obtenez</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
            Tout ce dont vous avez besoin<br />
            <span className="text-[#C9A227]">au même endroit</span>
          </h2>
          <p className="text-white/40 text-base max-w-lg mx-auto">
            AD.NOVA.PRO n&apos;est pas une formation. C&apos;est un écosystème complet pour réussir votre transition.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-[#0D1228] border border-white/[0.07] rounded-2xl p-6 hover:border-[#C9A227]/20 transition-colors group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#C9A227]/10 mb-5 group-hover:bg-[#C9A227]/20 transition-colors">
                <i className={`${f.icon} text-[#C9A227] text-lg`}></i>
              </div>
              <h3 className="text-white font-bold text-base mb-2">{f.title}</h3>
              <p className="text-white/40 text-sm leading-relaxed mb-5">{f.desc}</p>
              <div className="pt-4 border-t border-white/[0.07] flex items-baseline gap-1.5">
                <span className="text-2xl font-black text-[#C9A227]">{f.stat}</span>
                <span className="text-xs text-white/30 font-medium">{f.statLabel}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
